<script lang="ts">
    import { onMount } from 'svelte'
    import type { Person } from '../../../modules/eventsApi/persons/person'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import type { Referral } from '../../../modules/eventsApi/referrals/referral'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    dayjs.locale('pt-br')

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        const data: Person[] = await window.api.events.persons.getAll({ from, to, limit: 999999 })
        let referrals: Referral[] = await window.api.events.referrals.getAll()
        console.log('relat.data', data)
        grid = new GridClass()
        grid.title = 'Pessoas pela origem'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: 'Nascimento', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Origem', type: GridColTypeEnum.string }))
        for (const person of data) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: person.createdAt })
            line.slots.push({ content: person.name })
            line.slots.push({ content: person.phone })
            line.slots.push({ content: person.email })
            line.slots.push({ content: person.born })
            line.slots.push({
                content: referrals.find((el) => el.referralId === person.referralId)?.label || '[não informado]',
            })
            grid.lines.push(line)
        }
        grid = grid
        console.log('relat.grid', grid)
        show = false
    }

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
